import React from "react";

const About = () => {
  return <h1>MY CHAPTER</h1>;
};

export default About;